import React from 'react';
import PropTypes from 'prop-types';
import {Button} from 'antd';
import useDocumentFirestore from '@web/hooks/useDocumentFirestore';
import {CheckIcon} from '@web/assets/icons';
import {api} from '@web/lib/api';
import {notifyAndTrack} from './notification';
import {UserContext, WindowContext} from '@web/hooks/context';

ComposioConnectButton.propTypes = {
  appId: PropTypes.string,
};

function ComposioConnectButton({children, appId, ...props}) {
  const [userId] = React.useContext(UserContext);
  const [, width, height] = React.useContext(WindowContext);
  console.log("appId", appId);
  const [integration] = useDocumentFirestore(["user", userId, "integrations", appId].join("/"));

  /** @todo refactor to use our normal oauth flow */
  const onClickConnect = () => {
    api.LINE("/integration/connect", {
      appId,
    })
    .then((response) => {
      console.log("Connecting:", response);
      if (response.success && response.authUrl) {
        return window.open(response.authUrl, "_blank", `popup=true,width=800,height=800,noreferrer,left=${(width / 2) - 400},top=${(height / 2) - 400}`);
      }
      notifyAndTrack.warn(response.message ||"unable to connect at this time");
    })
    .catch((error) => {
      console.error("Error connecting to integration", error);
      notifyAndTrack.warn("Error connecting to integration", error.message);
    })
  }

  return integration?.connection?.status === "ACTIVE" ?
    <Button shape="round" size="large" className="icon-btn" {...props} disabled><CheckIcon /> Connected</Button> :
    <Button onClick={onClickConnect} shape="round" size="large" className="icon-btn orange-color" {...props}>{children}</Button>;
}

export default ComposioConnectButton;
